import {INIT_FAVORITES} from '~/GalleryPB/reducers/favorites';
import {SET_ACTIVE_FILTERS} from '~/GalleryPB/reducers/filters/constants';
import {INIT_FILTERS, UPDATE_ACTIVE_FILTERS} from '~/GalleryPB/reducers/galleryData';

export const getGalleryDataCallback = (store) => (data) => {
  const params = new URLSearchParams(window.location.search);

  let pageDisplayName =
    params.get('query') || // get query from URL if it exists
    window.seo_display_name ||
    data.displayName ||
    data.searchText || // only one of data.displayName and data.searchText will exist
    window.display_name || // use window.display_name if none of these exist
    ''; // finally, fall back to an empty string if NONE of these exist (super edge case)

  const previousCurrentPage = params.get('page') || 1;

  const urlPieces = window.location.pathname.split('/');
  if (urlPieces.includes('favorites')) {
    pageDisplayName = 'My Favorites';
  }

  // Save filter data in Redux
  store.dispatch({
    type: INIT_FILTERS,
    payload: {...data, pageDisplayName, previousCurrentPage},
  });
  const urlFilters = params.getAll('active_filter');

  const filtersToSubmit = urlFilters
    ? urlFilters.map((f) => {
        const pair = f.split(',');
        return {
          filterSection: pair[0],
          filterName: pair[1],
          on: true,
        };
      })
    : [];

  filtersToSubmit.forEach((f) =>
    store.dispatch({
      type: UPDATE_ACTIVE_FILTERS,
      payload: {
        sectionName: f.filterSection,
        filterName: f.filterName,
        apiResponse: data,
      },
    })
  );

  // Extract the user's favorites
  const favoritedTemplates = [];
  const allTemplates = [...data.freeTemplates, ...data.premiumTemplates];
  allTemplates.forEach((t) => {
    if (t.favorite) favoritedTemplates.push(t.templateId);
  });

  // Save the user's favorites
  store.dispatch({
    type: INIT_FAVORITES,
    payload: {favorites: favoritedTemplates},
  });

  store.dispatch({
    type: SET_ACTIVE_FILTERS,
    payload: filtersToSubmit,
  });
};
